'use strict';

var ModalManager = require('../ModalManager');

var ModalWizard = function(entranceLink, observeClick) {
    this.initialize(entranceLink, observeClick);
};

ModalWizard.prototype = {
    url: null,
    modal: null,
    className: null,

    /*
        Public Getters / Setters
    */
    getModal: function(){
        return this.modal;
    },
    setModal: function(modal){
        this.modal = modal;
    },
    getClassName: function(){
        return this.className;
    },
    setClassName: function(className){
        this.className = className;
    },
    getUrl: function() {
        return this.url;
    },
    setUrl: function(url) {
        this.url = url;
    },
    setMethod: function(method) {
        return this.getModal().setMethod(method);
    },
    /*
        Public Methods
    */
    initialize: function(entranceLink, observeClick){
        var entranceLinkElement = document.getElementById(entranceLink);
        if(entranceLinkElement){
            if(observeClick){
                jQuery(entranceLinkElement).on('click', jQuery.proxy(this._handleLinkClick, this), true);
            }
            this.url = entranceLinkElement.href;
        } else {
            this.url = entranceLink;
        }
        ModalManager._currentModalWizard = this;
        this.modal = ModalManager.getCurrentModal();
    },

    start: function(url, className, formData){
        this.getModal().setFormData(formData);
        this.getModal().activate(url || this.getUrl(), className || this.getClassName());
    },

    finish: function(){
        this.getModal().deactivate();
    },

    /*
        Private Methods
    */
    _handleLinkClick: function(e){
        hideCurrentMenu();
        e.stopPropagation();
        this.start();
    }
};

module.exports = ModalWizard;



//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/Modal/ModalWizard.js
// module id = 21
// module chunks = 0